<template>
  <div id="app">
    <div
      class="shop-header-margin shop-header-element-ui-less"
      :class="'shop-header-element-ui-less-' + data_info.nav_color"
    >
      <div class="top-one">
        <head_dianpu></head_dianpu>
      </div>
      <div class="top-two hidden-sm-and-down">
        <el-row>
          <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
            <div>
              <el-row :gutter="20">
                <el-col :xs="14" :sm="9" :md="9" :lg="7" :xl="7">
                  <img
                    src="../../../assets/home/logo.png"
                    style="width: 100%; height: 100%"
                  />
                </el-col>
                <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                  <div class="top-two_text">
                    <span style="float: left">{{ data_info.shop_name }}</span>
                    <div
                      class="follow"
                      style="color: #c60000; border: 1px solid #c60000"
                    >
                      <span v-if="data_info.auth_info.type == 1">个人</span>
                      <span v-if="data_info.auth_info.type == 2">企业</span>
                      <span v-if="data_info.auth_info.type == 3">企业</span>
                    </div>
                    <div
                      class="follow"
                      :class="data_info.nav_color + '_follow'"
                      @click="shouce1()"
                    >
                      {{ xiontai }}
                    </div>
                  </div>
                  <div class="label">
                    技能标签：
                    <el-tag
                      type="info"
                      style="margin-right: 5px"
                      size="mini"
                      v-for="(item, index) in data_info.skill"
                      :key="index"
                      >{{ item.tag_value }}
                    </el-tag>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :xs="24" :sm="20" :md="9" :lg="9" :xl="9">
            <div>
              <el-input
                size="small "
                placeholder="请输入内容"
                v-model="input3"
                class="input-with-select"
              >
                <el-select
                  class="xujz"
                  v-model="select"
                  slot="prepend"
                  placeholder="请选择"
                >
                  <el-option
                    v-if="data_info.auth_info.type !== 1"
                    label="在线商品"
                  ></el-option>
                  <el-option
                    label="在线服务"
                    value="#/shops/service/"
                  ></el-option>
                  <el-option label="成功案例" value="#/shops/case/"></el-option>
                  <el-option label="仪才秀" value="#/shops/video/"></el-option>
                  <el-option
                    label="小星点灯"
                    value="#/shops/light/"
                  ></el-option>
                  <el-option
                    label="应用方案"
                    value="#/shops/programme/"
                  ></el-option>
                  <el-option
                    label="行业标准"
                    value="#/shops/standard/"
                  ></el-option>
                </el-select>
                <el-button slot="append" @click="shijian">搜索</el-button>
              </el-input>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="top-three hidden-sm-and-down" :class="data_info.nav_color">
        <div class="hidden-sm-and-down three_pc">
          <a :href="'#/shops/index/' + list.shop_id">
            <div
              class="kuai"
              :class="
                $route.path === '/shops/index/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              首页
            </div>
          </a>
          <a
            :href="'#/shops/commodity/' + list.shop_id"
            v-if="data_info.auth_info.type !== 1"
          >
            <el-dropdown
              class="kuai1"
              :class="
                $route.path == '/shops/commodity/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              <span class="el-dropdown-link">在线商品</span>

              <el-dropdown-menu slot="dropdown" v-if="fuwu_list.length!=0">
                <a
                  :href="'#/shops/commodity/' + list.shop_id"
                  style="text-decoration: none"
                >
                  <el-dropdown-item
                    v-for="(shangpin, index) in shangpin_list"
                    :key="index"
                    >{{ shangpin.label }}
                  </el-dropdown-item>
                </a>
              </el-dropdown-menu>
            </el-dropdown>
          </a>
          <a :href="'#/shops/service/' + list.shop_id">
            <el-dropdown
              class="kuai"
              :class="
                $route.path == '/shops/service/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              <span class="el-dropdown-link">在线服务</span>

              <el-dropdown-menu slot="dropdown" v-if="fuwu_list.length!=0">
                <a
                  :href="'#/shops/service/' + list.shop_id"
                  style="text-decoration: none"
                >
                  <el-dropdown-item
                    v-for="(fuwu, index) in fuwu_list"
                    :key="index"
                    >{{ fuwu.label }}
                  </el-dropdown-item>
                </a>
              </el-dropdown-menu>
            </el-dropdown>
          </a>
          <a :href="'#/shops/case/' + list.shop_id">
            <div
              class="kuai"
              :class="
                $route.path == '/shops/case/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              成功案例
            </div>
          </a>
          <a :href="'#/shops/video/' + list.shop_id">
            <div
              class="kuai"
              :class="
                $route.path == '/shops/video/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              仪才秀
            </div>
          </a>
          <a :href="'#/shops/light/' + list.shop_id">
            <div
              class="kuai"
              :class="
                $route.path == '/shops/light/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              小星点灯
            </div>
          </a>
          <a :href="'#/shops/programme/' + list.shop_id">
            <div
              class="kuai"
              :class="
                $route.path == '/shops/programme/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              应用方案
            </div>
          </a>
          <a :href="'#/shops/standard/' + list.shop_id">
            <div
              class="kuai"
              :class="
                $route.path == '/shops/standard/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              行业标准
            </div>
          </a>
          <a :href="'#/shops/companyData/' + list.shop_id">
            <div
              class="kuai"
              :class="
                $route.path == '/shops/companyData/' + list.shop_id
                  ? data_info.nav_color + '_new'
                  : ''
              "
            >
              公司资料
            </div>
          </a>
        </div>
      </div>
      <el-container class="ciyemian_yibei_qiangzhi_buxudong flextext">
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no"
        />

        <el-main>
          <div class="contain">
            <!--          <div><a href="#" class="small-nav">全
                    部 》离子色谱仪&nbsp;阴阳离子检测仪水中离子测定仪</a></div>-->
            <div class="small-title">{{ list.title }}</div>
            <el-row :gutter="30">
              <el-col :xs="24" :sm="24" :md="9">
                <div class="shop_list">
                  <el-image
                    class="shop1"
                    :src="url + '/storage/' + list.cover"
                    fit="cover"
                  >
                    <div slot="error" class="image-slot">
                      <img
                        class="weijiazai_img_qiangzhi"
                        src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png"
                        alt=""
                        style="height: 220px"
                      />
                      <!--    <i class="el-icon-picture-outline"></i>-->
                    </div>
                  </el-image>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="15">
                <!--              <div class="shop-span">-->
                <!--                <ul style="position: absolute">-->
                <!--                  <li v-if="list.jiaofu==2">-->
                <!--                    现货-->
                <!--                  </li>-->

                <!--                  <li v-if="list.jiaofu==3">-->
                <!--                    订货-->
                <!--                    <div class="jiaofu_time">{{ list.jiaofu_date + '天' }}</div>-->
                <!--                  </li>-->
                <!--                </ul>-->

                <!--              </div>-->
                <div style="margin-bottom: 30px; margin-left: 50px">
                  <div>
                    <div class="guige_tou" v-if="type == 3 || type == 2">
                      <span style="margin-right: 65px; float: left"
                        >服务区域</span
                      >
                      <span v-for="(item, index) of fwsheng" :key="index">
                        {{
                          (index == fwsheng.length - 1 && item) || item + ","
                        }}
                      </span>
                    </div>
                    <div class="guige_tou" v-if="type == 1">
                      <span style="margin-right: 65px; float: left"
                        >服务区域</span
                      >
                      <span
                        v-for="(item, index) of fwsheng"
                        :key="index"
                        style="margin-right: 10px"
                        >{{ item }}</span
                      >
                      <span>:</span>
                      <span v-for="(item, index) of fwshi" :key="index">
                        {{ (index == fwshi.length - 1 && item) || item + "," }}
                      </span>
                    </div>

                    <el-divider class="hr"></el-divider>
                    <!-- <div class="guige_tou" >
                      <span style="margin-right: 65px; float: left"
                        >服务场景：</span
                      >
                      <div class="top_input">
                        {{ scene }}
                      </div>
                    </div> -->
                    <div class="top_box"> 
                       <div class="top_title">服务场景：</div>
                       <div class="top_input">{{ scene }}</div>
                    </div>
                    <el-divider class="hr"></el-divider>

                    <div class="top_box"> 
                       <div class="top_title">项目简介：</div>
                       <div class="top_input">{{ description }}</div>
                    </div>
                    <el-divider class="hr"></el-divider>
                    <!-- <span class="prices" v-if="list.price_yugu == 0.0"
                      >明码标价 <span class="moneys">¥</span
                      ><span class="value">{{ list.cash }}</span>
                    </span> -->
                    <!-- <span class="prices" v-else
                      >预估价格 <span class="moneys">¥</span
                      ><span class="value">{{ list.price_yugu }}</span>
                    </span> -->
                  </div>
                  <div
                    v-for="(item, index) of list.attachment"
                    v-bind:key="index"
                  >
                    <div class="guige_tou" v-if="item">
                      <span style="margin-right: 65px; float: left">附件</span>
                      <a
                        :href="url + '/storage/' + item.url"
                        style="display: block; float: left; margin-left: 35px"
                        target="_blank"
                      >
                        <el-link type="primary">{{ item.name }}</el-link>
                      </a>
                      <el-divider class="hr"></el-divider>
                    </div>
                  </div>
                  
                  <div
                    v-for="(item, index) of list.cert_file"
                    v-bind:key="index"
                  >
                    <div class="guige_tou" v-if="item.url">
                      <span style="margin-right: 65px; float: left"
                        >必要资质</span
                      >
                      <a
                        :href="url + '/storage/' + item.url"
                        style="display: block; float: left"
                      >
                        <el-link type="primary">{{ item.url }}</el-link>
                      </a>
                    </div>
                  </div>
                  <!--              <div class="guige_middle">-->
                  <!--                <div class="zizhi">必要资质</div>-->
                  <!--&lt;!&ndash;                <a :href="url+'/storage/'+list.cert_file.url" style="display: block; float: left">&ndash;&gt;-->
                  <!--&lt;!&ndash;                  <el-link type="primary">{{list.cert_file.name}}</el-link>&ndash;&gt;-->
                  <!--&lt;!&ndash;                </a>&ndash;&gt;-->
                  <!--              </div>-->
                </div>
                <!-- <el-divider class="hr"></el-divider> -->
                 <!-- <el-divider class="hr"></el-divider> -->
                <!-- <span
                  class="prices-one"
                  v-for="(item, index2) in list_guige"
                  :key="index2"
                >
                  <span style="display: block; float: left" v-if="index2 == 0"
                    >规格型号</span
                  >
                  <span
                    class="moneys-num"
                    :style="index2 == 0 ? '' : 'margin-left:135px; width:100px'"
                    >{{ item.specification }}</span
                  >
                  <span class="moneys-nums" style="width: 100px"
                    >{{ item.price * item.sum }}元</span
                  >
                  <span class="jibuqi">
                    <el-input-number
                      size="mini"
                      v-model="item.sum"
                      @change="handleChange2"
                      :min="0"
                      :max="10"
                      label="描述文字"
                    ></el-input-number>
                  </span>
                  <el-divider class="hrs"></el-divider>
                </span> -->

                <!--            <span class="prices-one" v-for="(item,index2) in list.specification" :key="index2" style="margin-left: 80px">-->
                <!--            <span class="moneys-num">{{ item.specification }}</span>-->
                <!--            <span class="moneys-nums">{{item.price}}元</span>-->
                <!--              <span class="jibuqi">-->
                <!--            <el-input-number  size="mini" v-model="num[index2]" @change="handleChange2" :min="0" :max="10"-->
                <!--                              label="描述文字"></el-input-number>-->
                <!--              </span>-->
                <!--              </span>-->
                <!--            <el-divider class="hrs"></el-divider>-->
                <!--            <div class="guige_tou" style="margin-bottom: 30px" v-if="list.attachment[0]">-->
                <!--              <span style="margin-right: 65px">附件</span>-->
                <!--              <a :href="url+'/storage/'+list.attachment[0].url">-->
                <!--                <el-link type="primary">{{list.attachment[0].name}}</el-link>-->
                <!--              </a>-->
                <!--            </div>-->
                <!-- <span class="buy">
                  <a :href="'#/service/purchase/' + list.id">
                    <el-button class="buy-button" type="primary"
                      >立即购买</el-button
                    >
                  </a>
                </span> -->
                <span class="buy">
                  <!--            <a :href="'#/purchase/'+list.id">-->
                  <el-button
                    class="buy-button"
                    type="primary"
                    @click="shouce(list.id)"
                    >{{ status }}</el-button
                  >
                </span>
              </el-col>
              <!--            <div class="guige_tou" style="margin-bottom: 30px" v-if="list.attachment[0]">-->
              <!--            <span class="prices-one" >附件</span>-->
              <!--            <a href="url+'/storage/'+list.attachment[0].url" class="moneys-img">asdfghjkli.jpg</a>-->
              <!--              <el-link type="primary">{{list.attachment[0].name}}</el-link>-->
              <!--            </div>-->
            </el-row>
            <div style="margin-bottom: 40px; height: 400px; width: 100%">
              <div class="aaa hidden-sm-and-down">
                <div class="xinxi" style="width: 230px; height: 272px">
                  <div
                    style="
                      background-color: #4e6ef2;
                      height: 45px;
                      width: 229px;
                      border-radius: 5px 5px 0px 0px;
                    "
                  >
                    <i class="el-icon-service"></i>
                    <span class="kefuzhongxin">客服中心</span>
                  </div>
                  <div>
                    <div class="center_title flex">
                      在线联系
                      <div class="yixiaoxing">
                        <img
                          src="../../../assets/home/yixiaoxing1.png"
                          alt=""
                          class="image"
                          @click="chat_list"
                        />
                      </div>
                    </div>

                    <p class="center_title">联系电话</p>
                    <p class="center_mintitle">{{ inform.mobile }}</p>
                    <p class="center_title">厂家地址</p>
                    <p class="center_mintitle">{{ sheng }}{{ shi }}{{ qv }}</p>
                  </div>
                </div>
              </div>
              <div class="bottom_right_background">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane label="详情描述" name="first">

                    <div class="serve_area_title">
                       服务领域
                    </div>
                    <div class="serve_area_inner">
                      <el-row
                          v-for="(item, index) in yingyong_hy.split(',')"
                          v-bind:key="index"
                          style="display: flex"
                        >
                          <el-col v-if="index % 2 == 0" class="title">
                            <block> {{ yingyong_hy.split(",")[index] }}</block>
                            <block class="title_list">
                              {{ yingyong_hy.split(",")[index + 1] }}</block
                            >
                          </el-col>
                        </el-row>
                    </div>
                    <div class="serve_area_title">
                      服务详情
                    </div>
                    <div class="serve_area_inner">
                        <block v-for="(item, index) in details" :key="index">
                          <div v-if="item.type == 'image'" class="image_box">
                            <img
                              :src="url + '/storage/' + item.url"
                              class="image"
                            />
                          </div>
                          <div v-if="item.type == 'input'" class="input" v-html="item.value">
                            <!-- {{ item.value }} -->
                          </div>
                        </block>
                      </div>
                      <div class="serve_area_inner" v-if="experiment.tableData">
                        <el-table
                        :data="experiment.tableData"
                        size="mini"
                        border
                        class="martop10"
                      >
                        <el-table-column
                          v-for="(item, index) in experiment.tableheader"
                          :key="index"
                          align="center"
                        >
                          <template #header>
                            <div style="display: inline">
                              <template>
                                {{ item.label }}
                              </template>
                            </div>
                          </template>

                          <template #default="{ row }">
                            <div
                              v-for="(item, key, i) in experiment.tableData[0]"
                              :key="i"
                            >
                              <template v-if="index == i">
                                {{ row[key] }}
                              </template>
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                      </div>
                    <div class="serve_area_title">
                      配套仪器设备
                    </div>
                    <div class="serve_yiqi">
                         <div v-for="(item,index) in parts" :key="index" class="image_box">
                        
                           <img :src="url + '/storage/' + item.url"
                              class="image"
                            />
                           <div class="image_name">{{item.name}}</div> 
                         </div>  
                      </div>
                    <!-- <div class="xiangqing_detail_box">  
                      <span style="float: left; margin-left: 23px"
                        >服务领域：</span
                      >
                      <span>
                        <el-row
                          v-for="(item, index) in yingyong_hy.split(',')"
                          v-bind:key="index"
                          style="display: flex"
                        >
                          <el-col v-if="index % 2 == 0" class="title">
                            <block> {{ yingyong_hy.split(",")[index] }}</block>
                            <block class="title_list">
                              {{ yingyong_hy.split(",")[index + 1] }}</block
                            >
                          </el-col>
                        </el-row>
                      </span>
                    </div> -->
                    <!-- <div class="xiangqing_detail_box">
                      <span style="float: left; margin-left: 23px"
                        >服务场景：</span
                      >
                      <div class="serve_scenario">
                        {{ scene }}
                      </div>
                    </div> -->
                    <!-- <div class="xiangqing_detail_box">
                      <span style="float: left; margin-left: 23px"
                        >项目简介：</span
                      >
                      <div class="serve_scenario">
                        {{ description }}
                      </div>
                    </div> -->
                    <!-- <div class="xiangqing_detail_box">
                      <span style="float: left; margin-left: 23px"
                        >服务详情：</span
                      >
                      <div class="serve_detail">
                        <block v-for="(item, index) in details" :key="index">
                          <div v-if="item.type == 'image'" class="image">
                            <img
                              :src="url + '/storage/' + item.url"
                              class="image"
                            />
                          </div>
                          <div v-if="item.type == 'input'" class="input">
                            {{ item.value }}
                          </div>
                        </block>
                      </div>
                    </div> -->
                    <!-- <div class="xiangqing_detail_box">
                      <span style="float: left; margin-left: 23px"></span>
                      <el-table
                        :data="experiment.tableData"
                        size="mini"
                        border
                        :header-row-style="{
                          background: '#eff4fd',
                          color: '#000',
                        }"
                        class="martop10"
                      >
                        <el-table-column
                          v-for="(item, index) in experiment.tableheader"
                          :key="index"
                          align="center"
                        >
                          <template #header>
                            <div style="display: inline">
                              <template>
                                {{ item.label }}
                              </template>
                            </div>
                          </template>

                          <template #default="{ row }">
                            <div
                              v-for="(item, key, i) in experiment.tableData[0]"
                              :key="i"
                            >
                              <template v-if="index == i">
                                {{ row[key] }}
                              </template>
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div> -->


                    <!-- <div class="xiangqing_detail_box">
                      <span style="float: left; margin-left: 23px"
                        >配套仪器设备：</span
                      >
                      <div class="serve_yiqi">
                         <div v-for="(item,index) in parts" :key="index" class="image_box">
                        
                           <img :src="url + '/storage/' + item.url"
                              class="image"
                            />
                           <div>{{item.name}}</div> 
                         </div>  
                      </div>
                    </div> -->
                    <!-- <div class="xiangqing_background1"></div> -->
                    <!-- <div class="xiangqing_background"> -->
                    <!--                    <div class="xiangqing_title" style="float: left;margin-left: 23px">-->
                    <!--                      行业领域：<span class="tanxing">{{yingyong_hy}}</span>-->
                    <!--                    </div>-->
                    <!-- <div class="xiangqing_title">
                        <span style="float: left; margin-left: 23px"
                          >服务领域：</span
                        > -->
                    <!-- <span>
                          <el-row
                            v-for="(item, index) in yingyong_hy.split(',')"
                            v-bind:key="index"
                            style="display: flex"
                          >
                            <el-col v-if="index % 2 == 0" class="title">
                              <block>
                                {{ yingyong_hy.split(",")[index] }}</block
                              >
                              <block class="title_list">
                                {{ yingyong_hy.split(",")[index + 1] }}</block
                              >
                            </el-col>
                          </el-row>
                        </span> -->
                    <!-- </div> -->

                    <!-- <div class="xiangqing_title">
                        <span style="float: left; margin-left: 90px"
                          >服务关键词：</span
                        >
                        <span>
                          <el-row
                            v-for="(item, index) in list.keywords.split(',')"
                            v-bind:key="index"
                            style="display: flex"
                          >
                            <el-col v-if="index % 2 == 0" class="title">
                              <block>
                                {{ list.keywords.split(",")[index] }}</block
                              >
                              <block class="title_list">
                                {{ list.keywords.split(",")[index + 1] }}</block
                              >
                            </el-col>
                          </el-row>
                        </span>
                      </div> -->
                    <!--                    <div class="xiangqing_title xianshi" style="text-overflow: ellipsis; overflow: hidden ;-->
                    <!--                    float: left;margin-left: 90px" :title="list.keywords">-->
                    <!--                      服务关键词：<span class="tanxing">{{list.keywords}}-->
                    <!--                    </span>-->
                    <!--                    </div>-->
                    <!-- </div> -->
                    <!-- <div class="clear"></div>
                    <div class="xiangqing_background1"></div> -->
                    <!-- <div
                      class="bottom_titlemiaoshu imgsize"
                      v-html="list.detail"
                    ></div> -->
                  </el-tab-pane>
                  <!--                <el-tab-pane label="配置方案" name="second">-->
                  <!--                  <div class="xiangqing_background1"></div>-->
                  <!--                  <div class="bottom_titlemiaoshu" v-html="list.configuration"></div>-->
                  <!--                </el-tab-pane>-->
                  <el-tab-pane label="案例解析" name="third">
                    <div class="xiangqing_background1"></div>
                    <div v-for="(item, index) of list.list_cases" :key="index">
                      <a
                        v-if="item"
                        v-bind:href="'#/dianpu_fuwucase/' + item.id"
                      >
                        <div
                          style="word-break: break-all"
                          class="bottom_titlemiaoshu"
                          v-html="item.title"
                        ></div>
                      </a>
                    </div>
                    <!--                  <a v-if="list.list_cases[0]" v-bind:href="'#/case_details/'+ list.list_cases[0].id">-->
                    <!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
                    <!--                         v-html="list.list_cases[0].title"></div>-->
                    <!--                  </a>-->
                    <!--                  <a v-if="list.list_cases[1]" v-bind:href="'#/case_details/'+ list.list_cases[1].id">-->
                    <!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
                    <!--                         v-html="list.list_cases[1].title"></div>-->
                    <!--                  </a>-->
                    <!--                  <a v-if="list.list_cases[2]" v-bind:href="'#/case_details/'+ list.list_cases[2].id">-->
                    <!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
                    <!--                         v-html="list.list_cases[2].title"></div>-->
                    <!--                  </a>-->
                  </el-tab-pane>
                  <el-tab-pane label="小星点灯" name="fourth">
                    <div class="xiangqing_background1"></div>
                    <div v-for="(item, index) of list.list_light" :key="index">
                      <a v-if="item" v-bind:href="'#/detailsfuwu/' + item.id">
                        <div
                          style="word-break: break-all"
                          class="bottom_titlemiaoshu"
                          v-html="item.title"
                        ></div>
                      </a>
                    </div>
                    <!--                  <div v-if="list.list_light[0]!==''" class="bottom_titlemiaoshu"  v-html="list.list_light[0].title"></div>-->
                    <!--                  <a v-if="list.list_light[0]" v-bind:href="'#/lighting_details/'+ list.list_light[0].id">-->
                    <!--                  <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
                    <!--                       v-html="list.list_light[0].title"></div>-->
                    <!--                </a>-->
                    <!--                  <a v-if="list.list_light[1]" v-bind:href="'#/lighting_details/'+ list.list_light[1].id">-->
                    <!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
                    <!--                         v-html="list.list_light[1].title"></div>-->
                    <!--                  </a>-->
                    <!--                  <a v-if="list.list_light[2]" v-bind:href="'#/lighting_details/'+ list.list_light[2].id">-->
                    <!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
                    <!--                         v-html="list.list_light[2].title"></div>-->
                    <!--                  </a>-->
                  </el-tab-pane>
                  <el-tab-pane label="应用方案" name="fifth">
                    <div class="xiangqing_background1"></div>
                    <div
                      v-for="(item, index) of list.list_applicationProgram"
                      :key="index"
                    >
                      <a
                        v-if="item"
                        v-bind:href="'#/college/programme/' + item.id"
                      >
                        <div
                          style="word-break: break-all"
                          class="bottom_titlemiaoshu"
                          v-html="item.title"
                        ></div>
                      </a>
                    </div>
                    <!--                  <a v-if="list.list_applicationProgram[0]"
                                                        v-bind:href="'#/college/programme/'+ list.list_applicationProgram[0].id">-->
                    <!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
                    <!--                         v-html="list.list_applicationProgram[0].title"></div>-->
                    <!--                  </a>-->
                    <!--                  <a v-if="list.list_applicationProgram[1]"-->
                    <!--                     v-bind:href="'#/college/programme/'+ list.list_applicationProgram[1].id">-->
                    <!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
                    <!--                         v-html="list.list_applicationProgram[1].title"></div>-->
                    <!--                  </a>-->
                    <!--                  <a v-if="list.list_applicationProgram[2]"-->
                    <!--                     v-bind:href="'#/college/programme/'+ list.list_applicationProgram[2].id">-->
                    <!--                    <div style="word-break:break-all;" class="bottom_titlemiaoshu"-->
                    <!--                         v-html="list.list_applicationProgram[2].title"></div>-->
                    <!--                  </a>-->
                  </el-tab-pane>
                  <el-tab-pane label="行业标准" name="sixth">
                    <div class="xiangqing_background1"></div>
                    <div v-for="(item, index) of list.list_norm" :key="index">
                      <a
                        v-if="item"
                        v-bind:href="'#/college/standard/' + item.id"
                      >
                        <div
                          style="word-break: break-all"
                          class="bottom_titlemiaoshu"
                          v-html="item.title"
                        ></div>
                      </a>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </el-main>
        <footerall></footerall>
      </el-container>
    </div>
  </div>
</template>

<script>
// import home_head from '../../common/home-head';
import { CodeToText } from "element-china-area-data";
import footerall from "../../common/footer";
import head from "../../common/head";
export default {
  name: "category",
  data: function () {
    return {
      favorite: false,
      is_open: {
        sousuo: 1,
        lanmu: 1,
      },
      data_info: "",
      select: "在线服务",
      input3: "",
      xiontai: "",
      config: {
        email: "",
        phone: "",
      },
      anli: [],
      diandeng: [],
      fangan: [],
      biaozhun: [],
      yingyong_hy: [],
      value: 5,
      shop_id: "",
      activeName: "first",
      list: "",
      status: "",
      list_guige: [],
      url: "",
      num: ["", "", ""],
      information: "",
      inform: "",
      imforid: "",
      fwsheng: [],
      fwshi: [],
      type: "",
      data_list: [],
      data_uid: "",
      inform_uid: "",
      scene: "",
      description: "",
      details: "",
      experiment: "",
      parts: "",
    };
  },
  components: {
    // 'home-head': home_head,
    head_dianpu: head,
    footerall,
  },
  methods: {
    chat_list() {
      // console.log(this.data_uid);
      if (this.data_uid != "") {
        window.location.href =
          "#/chat_room/" + this.data_uid + "?uid=" + this.inform_uid;
      } else {
        window.location.href = "/user.html";
      }
    },
    // 导航内容
    Changeshuju() {
      this.$store.commit("Changestate");
    },
    getConfig: function () {
      console.log("我是4");
      var t = this;
      // this.config.email = localStorage.getItem('site:email');
      // this.config.phone = localStorage.getItem('site:service-phone');
      if (!this.config.email || !this.config.phone) {
        let url = window.config.api_url + "/user/config/site";
        this.axios.get(url).then((res) => {
          t.config.email = res.data.site.email;
          t.config.phone = res.data.site["service-phone"];
          // localStorage.setItem('site:email', t.config.email);
          // localStorage.setItem('site:service-phone', t.config.phone);
        });
      }
    },
    guanzhu() {
      var t = this;
      var id = localStorage.getItem("token");
      var url =
        window.config.api_url +
        "/user/shop/focus/check/" +
        t.$route.params.id +
        "?token=" +
        id;
      t.axios.get(url).then((res) => {
        // console.log(res,89444444444)
        t.xiontai = res.data.focus == 1 ? "已关注" : "关注";
      });
    },
    shouce1() {
      // console.log(cet);
      var t = this;
      var id = localStorage.getItem("uid");
      var formData = new FormData();
      formData.append("token", id);
      formData.append("shop_id", this.$route.params.id);
      if (t.xiontai == "关注") {
        var url = window.config.api_url + "/user/shop/focus";
        t.axios.post(url, formData).then((res) => {
          // console.log(res)
          t.$code(res.data.status);
          if (res.data.status == 0) {
            t.open2("成功");
            // t.list_data()
            this.$router.go(0);
          }
          if (res.data.status != 0) {
            t.open3(res.data.description);
          }
        });
        this.xiontai = "已关注";
      } else {
        var url1 = window.config.api_url + "/user/shop/unfocus";
        t.axios.post(url1, formData).then((res) => {
          // console.log(res)
          t.$code(res.data.status);
          if (res.data.status == 0) {
            t.open2("成功");
            // t.list_data()
            this.$router.go(0);
          }
          if (res.data.status != 0) {
            t.open3(res.data.description);
          }
        });
        this.xiontai = "关注";
      }
    },
    shijian() {
      var t = this;
      if (t.input3) {
        t.$store.commit("shopsSearchValue", t.input3);
      }
      window.location = t.select + this.list.shop_id;
    },

    sousuo_xuanxiang(e) {
      this.is_open.sousuo = e;
      console.log(this.is_open.sousuo);
    },
    get_uidlist() {
      let t = this;
      let aid = localStorage.getItem("uid");
      let url = window.config.api_url + "/user/shop/info?token=" + aid; //返回101
      t.axios.get(url).then((res) => {
        t.data_list = res.data;
        t.data_uid = res.data.shop_info.uid;
      });
    },

    init() {
      this.get_uidlist();
      this.information = this.$store.state.information;
      this.url = window.config.api_url;
      this.list_data();
      this.zhuangtai();
      this.guanzhu();
      this.getConfig();
      // this.dianpu_list()
      // this.list_info()
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    zhuangtai() {
      // console.log("我是2");
      var t = this;
      var id = localStorage.getItem("token");
      var url =
        window.config.api_url +
        "/user/fuwu/focus/check/" +
        t.$route.params.id +
        "?token=" +
        id;
      t.axios.get(url).then((res) => {
        t.status = res.data.focus;
        t.status = res.data.focus == 0 ? "收藏服务" : "已收藏";
      });
    },
    shouce() {
      // console.log(cet);
      var t = this;
      var id = localStorage.getItem("uid");
      var formData = new FormData();
      formData.append("token", id);
      formData.append("fuwu_id", this.$route.params.id);
      if (t.status == "收藏服务") {
        var url = window.config.api_url + "/user/fuwu/focus";
        t.axios.post(url, formData).then((res) => {
          t.$code(res.data.status);
          if (res.data.status == 1) {
            t.open2("成功");
            this.$router.go(1);
          }
        });
        this.status = "已收藏";
      } else {
        var url1 = window.config.api_url + "/user/fuwu/unfocus";
        t.axios.post(url1, formData).then((res) => {
          // console.log(res)
          t.$code(res.data.status);
          if (res.data.status == 1) {
            t.open2("成功");
            this.$router.go(1);
          }
        });
        this.status = "收藏服务";
      }
    },
    dp_inform() {
      
      // console.log('你是大傻逼')
      var t = this;
      // console.log(t.imforid,'t.imforid;');
      var url = window.config.api_url + "/college/shop/info?id=" + t.imforid;
      t.axios.get(url).then((res) => {
        t.inform_uid = res.data.uid;
        t.inform = res.data;
        t.type = res.data.type;
        t.data_info = res.data;
        console.log("我是省", res.data.auth_info.province);
        CodeToText[res.data.auth_info.province] === undefined
          ? (t.sheng = res.data.auth_info.province_name)
          : (t.sheng = CodeToText[res.data.auth_info.province]);
        CodeToText[res.data.auth_info.city] === undefined
          ? (t.shi = res.data.auth_info.city_name)
          : (t.shi = CodeToText[res.data.auth_info.city]);
        CodeToText[res.data.auth_info.area] === undefined
          ? (t.qv = res.data.auth_info.area_name)
          : (t.qv = CodeToText[res.data.auth_info.area]);
      });
    },
    goumai_sj(e) {
      var t = this;
      var list_vu = [];
      t.list_guige.forEach(function (item) {
        if (item.sum !== 0) {
          list_vu.push({
            estimate: item.estimate,
            goods_id: item.goods_id,
            id: item.id,
            price: item.price,
            specification: item.specification,
            sum: item.sum,
          });
        }
      });
      if (list_vu == "") {
        return t.$message.error("请至少选择一个商品规格");
      }
      t.$store.commit("saveDbSource", list_vu);
      window.location = "#/purchase/" + e;
    },
    list_data() {
      console.log("我是1");
      var t = this;
      var url = window.config.api_url + "/college/fuwu/" + t.$route.params.id;
      t.axios.get(url).then((res) => {
        t.list = res.data;
        t.shop_id = res.data.shop_id;
        t.fwsheng = res.data.province.split(",").map((item) => {
          return CodeToText[item];
        });
        t.fwshi = res.data.city.split(",").map((item) => {
          return CodeToText[item];
        });
        t.imforid = res.data.shop_id;
        for (let i = 0; i < t.list.aac.length; i++) {
          t.yingyong_hy.push(t.list.aac[i].title);
        }
        t.yingyong_hy = t.yingyong_hy.join(",");
        t.scene = res.data.scene; //服务详情
        t.description = res.data.description; //项目简介
        t.details = JSON.parse(res.data.detail_json);
        t.experiment = JSON.parse(res.data.experiment);
        t.parts = JSON.parse(res.data.parts);
        t.dp_inform();
        // console.log(t.list_guige, 888888888888999999)
        t.shangpin_data();
        t.fuwu_data();
      });
    },
    shangpin_data() {
      var t = this;
      var url =
        window.config.api_url + "/college/shop/goods/cate?shop_id=" + t.shop_id;
      t.axios.get(url).then((res) => {
        if (res.data.status) {
          t.$code(res.data.status);
        }
        if (res.data.status == 401) {
          t.opent();
        }
        t.shangpin_list = res.data;
        console.log("sangpin_list", res.data);
        // t.zongshu = res.data.goods_list.total
        // t.yemashu =  res.data.goods_list.last_page
        // console.log(res)
      });
    },
    fuwu_data() {
      var t = this;
      var url =
        window.config.api_url + "/college/shop/fuwu/cate?shop_id=" + t.shop_id;
      t.axios.get(url).then((res) => {
        if (res.data.status) {
          t.$code(res.data.status);
        }
        if (res.data.status == 401) {
          t.opent();
        }
        t.fuwu_list = res.data;
        console.log("fuwu_list", res.data);
        // t.zongshu = res.data.goods_list.total
        // t.yemashu =  res.data.goods_list.last_page
        // console.log(res)
      });
    },
    fujiaxz(e) {
      this.$router.push(this.url + "/storage/" + e);
    },
    handleChange2(e) {
      this.$store.commit("savePath", e);
    },
    open3(eve) {
      //警告
      // var tishi = '最多只能设置三个标签'
      this.$message({
        showClose: true,
        message: eve,
        type: "warning",
      });
    },
    open2(eve) {
      //成功
      this.$message({
        showClose: true,
        message: eve,
        type: "success",
      });
    },
  },

  created() {
    this.init();
  },
  mounted() {
    setTimeout(() => {
      this.dp_inform();
    }, 500);
  },
  watch:{
    imforid(){
      this.dp_inform();
    }
  }
};
</script>
<style lang="less">
.home_shop_xiang_peizhi_qiangzhi_elementui_leixing {
  .el-tabs__nav-wrap::after {
    background-color: #ffffff !important;
    width: 0;
  }
}
</style>


<style>
.imgsize p img {
  max-width: 100%;
}
.xianshi {
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ciyemian_yibei_qiangzhi_buxudong .el-tabs__active-bar {
  background-color: #4e6ef2;
  left: 1px;
}

.ciyemian_yibei_qiangzhi_buxudong .el-icon-arrow-left:before {
  display: none !important;
}

.ciyemian_yibei_qiangzhi_buxudong .el-icon-arrow-right:before {
  display: none !important;
}

.ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
  /*padding: 0 14px!important;*/
  /*font-size: 14px!important;*/
  line-height: 47px;
  font-size: 18px !important;
  padding-right: 83px !important;
  /*margin-right: 88px;*/
  /*padding: 0 44px!important;*/
  height: 45px;
  font-weight: bold;
  color: #333333;
}

.el-tabs__nav-scroll {
  margin-left: 45px;
}

.ciyemian_yibei_qiangzhi_buxudong .el-tabs__item {
  padding: 0 !important;
}

.ciyemian_yibei_qiangzhi_buxudong .el-tab-pane {
  margin-left: 35px !important;
}

.ciyemian_yibei_qiangzhi_buxudong .xq_neirong2_bottom[data-v-7edfb125] {
  left: -10px;
}

@media screen and (min-width: 995px) and (max-width: 1500px) {
  .ciyemian_yibei_qiangzhi_buxudong .contain .shop {
    width: 100% !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
    padding-right: 25px !important;
    /*margin-right: 26px;*/
    font-size: 15px !important;
    /*padding-left: 25px;*/
    height: 45px;
    font-weight: bold;
    color: #333333;
  }
}

@media screen and (min-width: 750px) and (max-width: 995px) {
  .ciyemian_yibei_qiangzhi_buxudong .contain .shop {
    width: 100% !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
    padding-right: 24px !important;
    font-size: 16px !important;
    height: 45px;
    font-weight: bold;
    color: #333333;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    padding-left: 0px !important;
    margin-top: 25px;
  }
}

@media screen and (max-width: 750px) {
  .ciyemian_yibei_qiangzhi_buxudong .contain .shop {
    width: 100% !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .contain {
    width: 100% !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .moneys-num {
    margin-left: 55px !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .moneys-nums {
    margin-left: 45px !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
    padding-right: 4px !important;
    font-size: 13px !important;
    height: 45px;
    font-weight: bold;
    color: #333333;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    padding-left: 0px !important;
    margin-top: 25px;
  }

  .ciyemian_yibei_qiangzhi_buxudong .jibuqi {
    margin-left: 50px !important;
  }
}

.ciyemian_yibei_qiangzhi_buxudong .xq_neirong2_bottom div {
  margin-left: 23px;
  margin-right: 40px !important;
  float: left;
  font-size: 14px;
  color: #666666;
  line-height: 60px;
}

.jibuqi {
  margin-left: 68px;
}

.jibuqi .el-input__inner {
  padding: 0;
  border: 0px;
}

.ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-icon-minus:before {
  font-size: 14px !important;
  color: #ffffff;
  font-weight: bold;
  content: "\e6d8";
}

.ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-icon-plus:before {
  font-size: 14px !important;
  color: #ffffff;
  font-weight: bold;
  content: "\e6d9";
}

.jibuqi .el-input-number--mini {
  width: 98px;
}

.ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-input-number__increase {
  width: 27px;
  background: #4e6ef2 !important;
}

.ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-input-number__decrease {
  width: 27px;
  background: #4e6ef2 !important;
}
</style>
<style lang="less" scoped>
@import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";

@head_text: Source Han Sans CN;
@font-face {
}

@import "../../../assets/css/home";
@import "../../../assets/css/home_details";
//@import "../../../assets/css/goods_detailed";
.flextext {
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
}
</style>

<style lang="less">
@import "../../../assets/css/head_yangshi";
.shop-header-margin {
  width: 100%;

  .head_text {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 550;
    color: #333333;
    line-height: 38px;
  }

  .top-one {
    width: 100%;
    height: 38px;
    background: #f4f4f4;

    .header_pc {
      margin: 0 auto !important;
      max-width: 1200px;
      width: 90%;

      .head_dingbu {
        width: 100%;
        height: 38px;
        background: #f4f4f4;

        .head_width {
          width: 100%;
          max-width: 1200px;
          margin-right: auto;
          margin-left: auto;

          .head_dingwei {
            //float: ;
            margin-left: 5px;
            margin-top: 13px;
            position: absolute;
            width: 10px;
            height: 13px;
          }

          .head_youxiang {
            margin-left: 34px;
            margin-top: 13px;
            position: absolute;
            width: 17px;
            height: 13px;
          }

          .head_text_cao_left {
            margin-left: 26px;
          }

          .head_text_xiaoxi_left {
            margin-left: 57px;
          }

          .head_text_denglu_left {
            margin-left: 202px;
          }

          .head_text_shouye_left {
            margin-left: 48px;
          }

          .head_text_shangjia_left {
            margin-left: 44px;
          }

          .head_text_wode_left {
            margin-left: 46px;
          }

          .head_text_kefu_left {
            margin-left: 50px;
          }

          .head_text_wangzhan_left {
            margin-left: 34px;
          }

          .header_logo_top {
            margin-top: 32px;

            .header_logo {
              width: 181px;
              height: 48px;
              float: left;
            }

            .header_sousuo {
              width: 503px;
              height: 45px;
              margin-top: 20px;
              border: 3px solid #4e6ef2;
              border-radius: 5px 0px 0px 5px;
              //margin-left: 20%;
              float: left;

              .header_sousuo_logo {
                width: 14px;
                height: 14px;
                margin-top: 16px;
                margin-left: 13px;
                margin-right: 15px;
                float: left;
              }

              .header_sousuo_tuijian {
                position: absolute;
                margin-top: -22px;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #333333;
                float: left;
                margin-left: 45px;
              }

              .header_sousuo_tuijian_2 {
                margin-left: 125px;
              }

              .header_sousuo_tuijian_3 {
                margin-left: 205px;
              }

              .header_sousuo_tuijian_xuanzhong {
                padding: 5px 10px 1px 10px;
                background: #4e6ef2;
                margin-top: -29px;
                color: #ffffff;
                border-radius: 5px 5px 0px 0px;
              }
            }

            .header_sousuo_button {
              margin-top: 20px;
              border: none;
              width: 100px;
              height: 45px;
              background: #4e6ef2;
              border-radius: 0px 5px 5px 0px;

              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #ffffff;
            }
          }

          .header_gongye_lianjie {
            margin-top: 36px;

            .header_gongye_kuang {
              float: left;
              width: 220px;
              height: 45px;
              background: #4e6ef2;
              border-radius: 5px 5px 0px 0px;

              .header_gongye_kuang_text {
                //width: 74px;
                //height: 18px;
                cursor: pointer;
                float: left;
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                margin-top: 10px;
                margin-left: 22px;
                //line-height: 100px;
              }

              .header_gongye_kuang_zhuangtai {
                width: 40px;

                background: #ffffff;
                border-radius: 2px;
                float: left;
                margin-top: -2px;
                margin-left: 36px;
              }

              .header_gongye_kuang_zhuangtai2 {
                width: 40px;
                height: 3px;
                background: #ffffff;
                border-radius: 2px;
                float: left;
                margin-top: -2px;
                margin-left: 130px;
              }
            }

            .header_gongye_lianjie_qiota {
              float: left;
              margin-left: 50px;
              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #333333;
              margin-top: 8px;
              //line-height: 100px;
            }

            .header_gongye_lianjie_qiota_xuanzhong {
              font-size: 22px;
              //font-weight: bold;
              color: #4e6ef2;
              margin-top: 4px;
              //line-height: 100px;
            }
          }
        }
      }
    }

    .header_phone {
      background: #f4f4f4;
      color: #333333;
      line-height: 38px;
      font-size: 12px;
      padding-right: 15px;
      padding-left: 15px;
      font-family: Source Han Sans CN;
      font-weight: 600;

      .header_phone_name {
        float: left;
      }

      .head_phone_dingwei {
        float: left;
        width: 10px;
        margin-top: 12px;
        margin-left: 5px;
      }

      .head_phone_huanyi {
        float: left;
        margin-left: 12px;
      }

      .head_phone_xiaoxi_img {
        float: left;
        width: 18px;
        margin-top: 12px;
        margin-left: 20px;
      }

      .head_phone_xiaoxi {
        float: left;
        margin-left: 5px;
      }

      .head_phone_denglu {
        float: right;
        margin-right: 7px;
      }

      .head_phone_zhuce {
        float: right;
      }
    }
  }

  .top-two {
    margin: 36px auto !important;
    max-width: 1200px;
    width: 90%;

    .top-two_text {
      //width: 222px;
      //height: 27px;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      //float: left;
      .follow {
        margin-left: 10px;
        margin-top: 5px;
        float: left;
        width: 45px;
        height: 20px;
        border: 1px solid #4e6ef2;
        border-radius: 5px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #4e6ef2;
        line-height: 20px;
        text-align: center;
      }

      .theme_blue_follow {
        color: #4e6ef2;
        border: 1px solid #4e6ef2;
      }

      .theme_red_follow {
        //background:#ed3a3d;
        color: #ed3a3d;
        border: 1px solid #ed3a3d;
      }

      .theme_orange_follow {
        //background:#e86419;
        color: #e86419;
        border: 1px solid #e86419;
      }
    }

    .label {
      float: left;
      width: 100%;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
    }
  }

  .top-three {
    width: 100%;
    height: 55px;
    background: #4e6ef2;

    .three_pc {
      margin: 0 auto !important;
      max-width: 1200px;
      width: 90%;

      .kuai {
        float: left;
        text-align: center;
        // width: 11%;
        width: 9.7%;
        height: 55px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        line-height: 55px;
      }

      .new {
        width: 12%;
        font-size: 20px;
        background: linear-gradient(
          180deg,
          #738aea 0%,
          rgba(115, 138, 234, 0) 100%
        );
      }

      .theme_blue_new {
        width: 12%;
        font-size: 20px;
        background: linear-gradient(
          180deg,
          #738aea 0%,
          rgba(115, 138, 234, 0) 100%
        );
      }

      .theme_red_new {
        width: 12%;
        font-size: 20px;
        background: linear-gradient(
          180deg,
          #ef6668 0%,
          rgba(115, 138, 234, 0) 100%
        );
      }

      .theme_orange_new {
        width: 12%;
        font-size: 20px;
        background: linear-gradient(
          180deg,
          #e09f7a 0%,
          rgba(115, 138, 234, 0) 100%
        );
      }
    }

    .three_phone {
    }
  }

  .theme_blue {
    background: #4e6ef2;
  }

  .theme_red {
    background: #ed3a3d;
  }

  .theme_orange {
    background: #e86419;
  }
}
</style>
<style lang="less">
.shop-header-element-ui-less {
  .el-select .el-input {
    width: 100px;
  }

  .el-input__inner {
    border-top: 1px solid #4e6ef2;
    border-bottom: 1px solid #4e6ef2;
    border-left: none;
    border-right: none;
  }

  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

  .el-input-group__append,
  .el-input-group__prepend {
    background-color: #4e6ef2;
    color: #ffffff;
    border: 1px solid #4e6ef2;
  }

  .xujz {
    .el-input__inner {
      color: #333333 !important;
    }
  }

  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: #4e6ef2;
  }

  .el-input--small .el-input__inner {
    height: 46px;
  }
}

.shop-header-element-ui-less-theme_blue {
  .el-select .el-input {
    width: 100px;
  }

  .el-input__inner {
    border-top: 1px solid #4e6ef2;
    border-bottom: 1px solid #4e6ef2;
    border-left: none;
    border-right: none;
  }

  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

  .el-input-group__append,
  .el-input-group__prepend {
    background-color: #4e6ef2;
    color: #ffffff;
    border: 1px solid #4e6ef2;
  }

  .xujz {
    .el-input__inner {
      color: #333333 !important;
    }
  }

  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: #4e6ef2;
  }

  .el-input--small .el-input__inner {
    height: 46px;
  }
}

.shop-header-element-ui-less-theme_red {
  .el-select .el-input {
    width: 100px;
  }

  .el-input__inner {
    border-top: 1px solid #ed3a3d;
    border-bottom: 1px solid #ed3a3d;
    border-left: none;
    border-right: none;
  }

  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

  .el-input-group__append,
  .el-input-group__prepend {
    background-color: #ed3a3d;
    color: #ffffff;
    border: 1px solid #ed3a3d;
  }

  .xujz {
    .el-input__inner {
      color: #333333 !important;
    }
  }

  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: #ed3a3d;
  }

  .el-input--small .el-input__inner {
    height: 46px;
  }
}

.shop-header-element-ui-less-theme_orange {
  .el-select .el-input {
    width: 100px;
  }

  .el-input__inner {
    border-top: 1px solid #e86419;
    border-bottom: 1px solid #e86419;
    border-left: none;
    border-right: none;
  }

  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

  .el-input-group__append,
  .el-input-group__prepend {
    background-color: #e86419;
    color: #ffffff;
    border: 1px solid #e86419;
  }

  .xujz {
    .el-input__inner {
      color: #333333 !important;
    }
  }

  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: #e86419;
  }

  .el-input--small .el-input__inner {
    height: 46px;
  }
}

.xixixi {
  display: inline-block;
  position: absolute;
  right: 0;
}
.el-icon-service {
  color: white;
  width: 18px;
  height: 18px;
  margin-left: 25px;
  margin-top: 18px;
}
.kefuzhongxin {
  font-family: Source Han Sans CN;
  font-size: 18px;
  color: white;
  font-weight: bold;
}
.center_title {
  width: 272px;
  height: 16px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  margin-left: 25px;
  margin-top: 19px;
}

.center_mintitle {
  width: 272px;
  height: 16px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  color: #333333;
  margin-left: 25px;
  margin-top: 15px;
}
.flex {
  display: flex;

  //  justify-content:space-around;
  .yixiaoxing {
    height: 25px;
    width: 25px;
    margin-left: 50px;
    // background-color: #ccc;
    display: inline-block;

    .image {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

/*.head_dingwei{*/
/*  width: 10px;*/
/*  height: 13px;*/
/*}*/
/*.head_youxiang{*/
/*  */
/*}*/
</style>

